import { createFileRoute } from "@tanstack/react-router";
import { Layout, Section, Eyebrow, FinalCTA, Breadcrumbs } from "@/components/site/Layout";
import { PricingGrid } from "@/components/site/Pricing";
import { breadcrumbSchema, jsonLdScript, organizationSchema } from "@/lib/seo";

export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: "Law Firm SEO Pricing | Transparent Monthly Packages" },
      { name: "description", content: "Transparent SEO pricing for law firms. Starter, Growth, and Enterprise plans built around case-type economics, not arbitrary 'tiers'." },
      { property: "og:title", content: "Law Firm SEO Pricing | PageOne Lawyers" },
      { property: "og:description", content: "Honest, transparent law firm SEO pricing." },
      { property: "og:url", content: "https://pageonelawyers.com/pricing" },
    ],
    links: [{ rel: "canonical", href: "https://pageonelawyers.com/pricing" }],
    scripts: [
      jsonLdScript(organizationSchema()),
      jsonLdScript(breadcrumbSchema([
        { label: "Home", path: "/" },
        { label: "Pricing", path: "/pricing" },
      ])),
    ],
  }),
  component: Pricing,
});

function Pricing() {
  return (
    <Layout>
      <section className="bg-hero-gradient text-primary-foreground">
        <div className="mx-auto max-w-7xl px-5 py-12 text-center sm:px-6 sm:py-20">
          <div className="text-left"><Breadcrumbs items={[{ label: "Home", href: "/" }, { label: "Pricing" }]} /></div>
          <Eyebrow><span className="text-[var(--gold)]">Pricing</span></Eyebrow>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl md:text-6xl font-semibold">Law firm SEO plans starting at $200/month.</h1>
          <p className="mt-6 text-lg text-primary-foreground/80 max-w-2xl mx-auto">Six transparent packages, from solo attorneys to enterprise firms. No setup fees. No surprise add-ons. Transparent reporting on rankings, calls and signed cases in every plan.</p>
        </div>
      </section>
      <Section>
        <PricingGrid />
        <p className="mt-12 text-center text-sm text-muted-foreground">All plans include attorney-reviewed content, white-glove onboarding, and complete transparency on every deliverable.</p>
      </Section>
      <FinalCTA title="Not sure which plan fits?" sub="Book a 20-minute call. We'll review your market, your competitors, and tell you exactly what's needed, even if that's less than you expected." />
    </Layout>
  );
}